import { Fragment, memo } from "react";
import CustomNode from "./components/CustomNode";
import SoftBox from "components/SoftBox";

function CommonComponentNode({ data, id, selected }) {
  let whatNode = data;
  whatNode.id = id;

  const generateTooltip = (elem) => {
    const description =
      elem?.data?.description?.value ||
      elem?.description?.value ||
      elem?.data?.description ||
      elem?.description ||
      "";
    return (
      <Fragment>
        <SoftBox className="custom-node-tooltip">
          <p className="custom-node-tooltip-description"> {description}</p>
        </SoftBox>
      </Fragment>
    );
  };

  return (
    <CustomNode
      isCommon
      data={data}
      id={id}
      selected={selected}
      generateTooltip={generateTooltip}
    />
  );
}

export default memo(CommonComponentNode);
